(function () {
  angular
    .module('app')
    .directive('vlite', vlite);

  vlite.$inject = ['$timeout'];
  function vlite($timeout) {
    return {
      require: ['^swiperVideo','ngModel'],
      scope: {
        options: "=",
        seenvideo: '='
      },
      link: function (scope, element, $attrs, swiperVideo) {
        return $timeout(function () {
          var options = {};
          if (scope.options) {
            options = scope.options;
          }

          var videoId = $(element).attr("id");
          var totalVideos = $('video').length;
          scope.videosVistos = new Array(totalVideos).fill(false);  // Inicializa una matriz

          $element = $(element);

          video = new window.Vlitejs(document.querySelector('#' + videoId), {
            options: {
              autoplay: false,
              playPause: true,
            },
            provider: options.provider,
            onReady: (player) => {
              player.on('ended', () => {
                console.log("ENDED VIDEO");
                
                var videoIndex = parseInt(videoId.replace('player', ''), 10);
                
                swiperVideo[1].$setViewValue(true); 

              });
            }
          });

          swiperVideo[0].videop.push(video);
        });
      }
    }
  }
})();


